module.exports = __webpack_public_path__ + "static/media/game-display-2.0861f7df.png";